import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { FetchCompanyDetail } from "./CompanySlice";
import moment from "moment";
import Loader from "../../component/Loader";
import BackButton from "./../../component/BackButton";

function ViewCompany() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const details = useSelector((state) => state.company.details);
  const [loading, setLoading] = useState(false);

  const maskPassword = (password) => {
    const length = password.length;
  
    if (length <= 2) {
      return "*".repeat(length); // fully hide very short passwords
    }
  
    if (length <= 6) {
      // show only first 1 char, mask the rest
      return password.slice(0, 1) + "*".repeat(length - 1);
    }
  
    if (length <= 10) {
      // show first 2 and last 2
      return (
        password.slice(0, 2) +
        "*".repeat(length - 4) +
        password.slice(-2)
      );
    }
  
    // long passwords: show first 3 and last 3
    return (
      password.slice(0, 3) +
      "*".repeat(length - 6) +
      password.slice(-3)
    );
  };
  

  const getDetails = useCallback(() => {
    setLoading(true);
    dispatch(FetchCompanyDetail({ id })).then(() => {
      setLoading(false);
    });
  }, [dispatch, id]);

  useEffect(() => {
    getDetails();
 
  }, [getDetails]);

  if (loading) {
    return (
      <article className="col-lg-9 articleClass">
        <Loader />
      </article>
    );
  } else {
    return (
      <article className="col-lg-9 articleClass">
        <div className="article-body store-bd-gy">
          <div className="row align-items-center col-rever">
            <BackButton />
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
              <h3>Company Details</h3>
            </div>
          </div>
          <div className="row mt-5 px-md-5">
            <div className="col-12 mb-3">
              {details?.banner ? (
                <div
                  className="position-relative"
                  style={{
                    width: "100%",
                    height: "250px",
                    overflow: "hidden",
                    borderRadius: "8px",
                  }}
                >
                  <img
                    src={details.banner}
                    alt="Company Banner"
                    className="img-fluid w-100 h-100"
                    style={{ 
                      objectFit: "contain"
                    }}
                  />

                  {details?.logo && (
                    <div style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      textAlign: "center"
                    }}>
                      <img
                        src={details.logo}
                        alt="Company Logo"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "100px",
                          backgroundColor: "#fff",
                          padding: "2px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                        }}
                      />
                    </div>
                  )}
                </div>
              ) : details?.logo ? (
                <div style={{
                  textAlign: "center",
                  padding: "20px"
                }}>
                  <img
                    src={details.logo}
                    alt="Company Logo"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      borderRadius: "100px",
                      backgroundColor: "#fff",
                      padding: "2px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                    }}
                  />
                </div>
              ) : null}
            </div>
          </div>

          <div className="row mt-5 px-md-5">
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Company Name</p>
                <h6 className="">
                  <img
                    src="assets/images/First-Name.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.company_name || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Trading Name</p>
                <h6 className="text-break text-transform-lowercase">
                  <img
                    src="assets/images/Email-Address.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.trading_name || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Website</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/Date-of-Birth.png"
                    className="detail-icon"
                    alt=""
                  />
                   {details?.website
                    ? `${details?.website}`
                    : "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">VAT Number</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/Date-of-Birth.png"
                    className="detail-icon"
                    alt=""
                  />
                   {details?.vat_number
                    ? `${details?.vat_number}`
                    : "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Business Type</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/Date-of-Birth.png"
                    className="detail-icon"
                    alt=""
                  />
                   {details?.business_type
                    ? `${details?.business_type}`
                    : "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Registration Number</p>
                <h6 className="">
                  <img
                    src="assets/images/mobile.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.registration_number
                    ? `${details?.registration_number}`
                    : "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-12 mt-5 mb-2">
              <h5>Primary Contact Information
              </h5>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Full Name</p>
                <h6 className="">
                  <img
                    src="assets/images/edu-black.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.full_name || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Job Title</p>
                <h6 className="">
                  <img
                    src="assets/images/expertise.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.job_role || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Email</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/award.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.email || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Phone Number</p>
                <h6 className="">
                  <img
                    src="assets/images/edu-black.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.phone_number || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-12 mt-5 mb-2">
              <h5>Business Address
              </h5>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Address</p>
                <h6 className="">
                  <img
                    src="assets/images/address.png"
                    className="detail-icon addressIcon"
                    alt=""
                  />
                  {
                   `${details?.address_line1}, ${
                        details?.address_line2
                          ? details?.address_line2 + ", "
                          : ""
                      } ${details?.city}, ${details?.county}, ${details?.country} - ${
                        details?.postcode
                      }`
                   }
                </h6>
              </div>
            </div>
            <div className="col-sm-12 mt-5 mb-2">
              <h5>Business Operations
              </h5>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Services Offered</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/award.png"
                    className="detail-icon"
                    alt=""
                  />
                  {Array.isArray(details?.services)
                    ? details.services.join(", ")
                    : (() => {
                        try {
                          const arr = JSON.parse(details?.services);
                          return Array.isArray(arr) ? arr.join(", ") : details?.services || "NA";
                        } catch {
                          return details?.services || "NA";
                        }
                      })()
                  }
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Target Age Range</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/award.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.target_age || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Estimated Weekly Bookings</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/award.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.no_of_weekly_bookings || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Typical Operating Hours</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/award.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.operating_hours || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-12 mt-5 mb-2">
              <h5>Platform Preferences
              </h5>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Booking Cancellation Policy</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/award.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.booking_cancellation_policy
                    ? (
                        <a
                          href={details.booking_cancellation_policy}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View PDF
                        </a>
                      )
                    : "NA"
                  }
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Custom Features</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/award.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.notes || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">Pricing Strucuture</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/award.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.pricing_structure || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-12 mt-5 mb-2">
              <h5>Stripe Connect Account
              </h5>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <h6 className="">
                  {details?.stripe_account_id || "NA"}
                </h6>
              </div>
            </div>

            <div className="col-sm-12 mt-5 mb-2">
              <h5>SMTP Configuration
              </h5>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">SMTP Host</p>
                <h6 className="">
                  <img
                    src="assets/images/edu-black.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.smtp_host || "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">SMTP Username</p>
                <h6 className="">
                  <img
                    src="assets/images/expertise.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.smtp_username
                    ? maskPassword(details.smtp_username)
                    : "NA"}
                </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">SMTP Password</p>
                <h6 className="text-break">
                  <img
                    src="assets/images/award.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.smtp_password
                    ? maskPassword(details.smtp_password)
                    : "NA"}
              </h6>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-3">
              <div className="bg-white px-5 py-3 text-capitalize position-relative h-100">
                <p className="mb-1">SMTP From Email</p>
                <h6 className="">
                  <img
                    src="assets/images/edu-black.png"
                    className="detail-icon"
                    alt=""
                  />
                  {details?.smtp_from_email || "NA"}
                </h6>
              </div>
            </div>

          </div>
        </div>
      </article>
    );
  }
}

export default ViewCompany;
